export const handlePriceByComma = (price = 0) => {
  return new Intl.NumberFormat("en-US").format(
    `${price}`?.endsWith("00") ? price?.toFixed(2) : price
  );
};
